import { useState, RefObject } from 'react';
import { useIntersectionObserver } from './use-intersection-observer';

/**
 * Проверяет находится ли элемент во вью порте
 * @param {RefObject<HTMLElement>}  ref
 * @param {IntersectionObserverInit} [options]
 */
export const useIsInViewport = (ref: RefObject<HTMLElement>, options?: IntersectionObserverInit) => {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useIntersectionObserver(ref, ([entry]) => (
    setIsIntersecting(entry.isIntersecting)
  ), options);

  return isIntersecting;
};
